import { capitalize, snakeCase } from "lodash"
import { spendAndFeesChartOptions, spendVBudgetedChartOptions } from "../src/chart_defaults"
import { numberToCurrency, addCurrencyColor, downloadLink } from "../src/tools"
import { formatDate } from "../src/utils"

const SPEND_AND_FEES_CONTEXT_ID = 'spend-and-fees-chart'
const PRODUCT_SPEND_KEY = 'product_total'
const LABOR_SPEND_KEY = 'personnel_total'
const EQUIPMENT_SPEND_KEY = 'equipment_total'
const MANAGEMENT_SPEND_KEY = 'management_fees_total'
let spendAndFeesChart, productBreakdownChart, laborBreakdownChart, equipmentBreakdownChart, managementBreakdownChart
let request

function bindSpendAndFeesPage() {
  new CraftySelect2({
    select: jQuery(".spend-and-fees-content #budget_id"),
    onSelect: fetchSpendAndFeesReport,
  }).init()

  jQuery('.spend-and-fees-content .date-holder').on('dateSelected', function() {
    fetchSpendAndFeesReport()
  })

  bindReportGrouping()
  bindDownloadSpendAndFeesLink()

  intitalizeSpendAndFeesChart()
  initializeSpendAndFeesBreakdownCharts()
  bindDetailLinks()
}

function bindReportGrouping() {
  jQuery(".spend-and-fees-content input[name='budget-view-toggle']").change(function() {
    fetchSpendAndFeesReport()
  })
}

function bindDetailLinks() {
  jQuery('.spend-and-fees-content .snapshot-link').on('click', function(e) {
    e.stopPropagation()
    const baseUrl = jQuery(this).data('link')
    const data = reportData('pohlio')
    const selected = jQuery(".spend-and-fees-content #budget_id").val()
    const params = $.param({ ...data, selected })
    const fullPath = baseUrl + '?' + params
    window.location.href = fullPath
  })
}

function bindDownloadSpendAndFeesLink() {
  jQuery('.spend-and-fees-download-link').click(downloadSpendAndFeesLink)
}

function downloadSpendAndFeesLink(e) {
  e.preventDefault()
  const data = reportData('spend_and_fees')
  const link = jQuery(this).data('link')
  if (data && !data.budget_id && !data.budget_group_id) return
  downloadLink(link, data)
}

function intitalizeSpendAndFeesChart() {
  const ctx = document.getElementById(SPEND_AND_FEES_CONTEXT_ID)
  if (ctx === null) return
  ctx.style.display = 'none'
  spendAndFeesChart = new Chart(ctx, {
    type: 'bar',
    options: spendAndFeesChartOptions,
  })
  fetchSpendAndFeesReport()
}

function initializeSpendAndFeesBreakdownCharts() {
  const ctxP = document.getElementById(`${PRODUCT_SPEND_KEY}-breakdown-chart`)
  if (ctxP === null) return
  ctxP.style.display = 'none'
  productBreakdownChart = new Chart(ctxP, {
    type: 'bar',
    options: spendVBudgetedChartOptions,
  })

  const ctxL = document.getElementById(`${LABOR_SPEND_KEY}-breakdown-chart`)
  if (ctxL === null) return
  ctxL.style.display = 'none'
  laborBreakdownChart = new Chart(ctxL, {
    type: 'bar',
    options: spendVBudgetedChartOptions,
  })

  const ctxE = document.getElementById(`${EQUIPMENT_SPEND_KEY}-breakdown-chart`)
  if (ctxE === null) return
  ctxE.style.display = 'none'
  equipmentBreakdownChart = new Chart(ctxE, {
    type: 'bar',
    options: spendVBudgetedChartOptions,
  })

  const ctxM = document.getElementById(`${MANAGEMENT_SPEND_KEY}-breakdown-chart`)
  if (ctxM === null) return
  ctxM.style.display = 'none'
  managementBreakdownChart = new Chart(ctxM, {
    type: 'bar',
    options: spendVBudgetedChartOptions,
  })
}

function fetchSpendAndFeesReport() {
  spendAndFeesChart.reset()

  if (jQuery(".spend-and-fees-content #budget_id").val()) {
    request = jQuery.ajax({
      url: jQuery('#spend-and-fees-wrapper').data('link'),
      type: "GET",
      dataType: "json",
      data: reportData('spend_and_fees'),
      success: function(res) {
        const data = res.data
        updateSpendAndFeesChart(data)
        updateSpendAndFeesTable(data)
        updateSpendAndFeesBreakdowns(data)
      },
      beforeSend: function () {
        if (request != null) {
          request.abort()
        }
      },
      complete: function () {
        request = null
      },
    })
  }
}

function updateSpendAndFeesChart(data) {
  const ctx = document.getElementById(SPEND_AND_FEES_CONTEXT_ID)
  ctx.style.display = 'block'
  const { labels, datasets } = data
  spendAndFeesChart.data = { labels, datasets }
  spendAndFeesChart.update()
}

function updateSpendAndFeesTable(data) {
  const { labels, datasets } = data
  const tableData = datasets.map( (c) => {
    return { color: c.backgroundColor, values: c.data, label: c.label, id: c.labelId }
  })

  const $table = $('#spend-and-fees-table')
  $table.children().remove()

  const $header = createSpendAndFeesHeader(labels)
  const $product = createSpendAndFeesRow(tableData, PRODUCT_SPEND_KEY)
  const $labor = createSpendAndFeesRow(tableData, LABOR_SPEND_KEY)
  const $equipment = createSpendAndFeesRow(tableData, EQUIPMENT_SPEND_KEY)
  const $management = createSpendAndFeesRow(tableData, MANAGEMENT_SPEND_KEY)

  $table.append($header).append($product).append($labor).append($equipment).append($management)
}

function createSpendAndFeesHeader(headers) {
  const $row = $('<tr>')
  $row.append($('<th>').text(''))
  $row.append($('<th>').text(''))
  headers.forEach( c => {
    $row.append($('<th>').text(c))
  })
  $row.append($('<th>').text('Total'))
  return $('<thead>').append($row)
}

function createSpendAndFeesRow(tableData, type) {
  const rowData = tableData.find(c => c.id == type)
  const values = rowData.values
  const $row = $('<tr>')
  const $colorDiv = $('<div>').addClass('table-legend__box').css('background-color', rowData.color)
  $row.append($('<td>').append($colorDiv))
  $row.append($('<td>').text(rowData.label))
  values.forEach( c => {
    const $td = $('<td>').text(numberToCurrency(c))
    $row.append($td)
  })
  const total = values.reduce((a, b) => safeNumber(a) + safeNumber(b), 0)
  const $totalCell = $('<td>').text(numberToCurrency(total))
  $row.append($totalCell)
  return $row
}

function updateSpendAndFeesBreakdowns(data) {
  updateSpendAndFeesBreakdownChart(PRODUCT_SPEND_KEY, productBreakdownChart, data)
  updateSpendAndFeesBreakdownTable(PRODUCT_SPEND_KEY, data)

  updateSpendAndFeesBreakdownChart(LABOR_SPEND_KEY, laborBreakdownChart, data)
  updateSpendAndFeesBreakdownTable(LABOR_SPEND_KEY, data)

  updateSpendAndFeesBreakdownChart(EQUIPMENT_SPEND_KEY, equipmentBreakdownChart, data)
  updateSpendAndFeesBreakdownTable(EQUIPMENT_SPEND_KEY, data)

  updateSpendAndFeesBreakdownChart(MANAGEMENT_SPEND_KEY, managementBreakdownChart, data)
  updateSpendAndFeesBreakdownTable(MANAGEMENT_SPEND_KEY, data)
}

function updateSpendAndFeesBreakdownChart(key, chart, data) {
  const { labels, breakdown_datasets } = data
  const datasets = breakdown_datasets[key]
  const ctx = document.getElementById(`${key}-breakdown-chart`)

  if (ctx === null) return

  ctx.style.display = 'block'
  chart.data = { labels, datasets }
  chart.update()
}

function updateSpendAndFeesBreakdownTable(key, data) {
  const { labels, breakdown_datasets } = data
  const datasets = breakdown_datasets[key]

  const $table = jQuery(`#${key}-breakdown-table`)

  const budgetedData = datasets.find(data => data.label === 'Budgeted')
  const spendData = datasets.find(data => data.label === 'Spend')
  const tableLabel = spendData.tableLabel

  const tableData = labels.map((label, idx) => {
    const budgeted = safeNumber(budgetedData.data[idx])
    const spend = safeNumber(spendData.data[idx])
    const remaining = budgeted - spend
    return { header: label, budgeted, spend, remaining, budgetedColor: budgetedData.backgroundColor, spendColor: spendData.backgroundColor}
  })

  $table.children().remove()

  const $header = createSpendAndFeesBreakdownHeader(labels, tableLabel)
  const $budgeted = createSpendVBudgetedBreakdownRow(tableData, 'budgeted')
  const $spend = createSpendVBudgetedBreakdownRow(tableData, 'spend')
  const $remaining = createSpendVBudgetedBreakdownRow(tableData, 'remaining')
  $table.append($header).append($budgeted).append($spend).append($remaining)
}

function createSpendAndFeesBreakdownHeader(headers, tableLabel) {
  const $row = $('<tr>')
  $row.append($('<th class="color-td">').text(''))
  $row.append($('<th>').text(tableLabel))
  headers.forEach( c => {
    $row.append($('<th>').text(c))
  })
  $row.append($('<th>').text('Total'))
  return $('<thead>').append($row)
}

function createSpendVBudgetedBreakdownRow(tableData, type) {
  const values = tableData.map(c => Number(c[type]))
  const $row = $('<tr>')
  const $colorDiv = $('<div>').addClass('table-legend__box').css('background-color', tableData[0][`${type}Color`])
  if (type === 'budgeted') {
    $colorDiv.css('border-radius', '100%')
  }
  $row.append($("<td class='color-td'>").append(type === 'remaining' ? "" : $colorDiv))
  $row.append($('<td>').text(capitalize(type)))

  values.forEach( c => {
    const $td = $('<td>').text(numberToCurrency(c))
    if (type === 'remaining') {
      addCurrencyColor($td, c)
    }
    $row.append($td)
  })
  const total = values.reduce((a, b) => safeNumber(a) + safeNumber(b), 0)
  const $totalCell = $('<td>').text(numberToCurrency(total))
  if (type === 'remaining') {
    addCurrencyColor($totalCell, total)
  }
  $row.append($totalCell)
  return $row
}

function reportData(reportName) {
  const from_range = formatDate(jQuery(".spend-and-fees-content #range_from").val())
  const to_range = formatDate(jQuery(".spend-and-fees-content #range_to").val())
  const group = reportGrouping()
  const $selectedBudget = jQuery(".spend-and-fees-content #budget_id")
  const selectedValue = $selectedBudget.val()
  const [row_type, id] = selectedValue.split("-")
  return { [`${snakeCase(row_type)}_id`]: id, row_type, to_range, group, from_range, report_name: reportName }
}

function reportGrouping() {
  if (jQuery(".spend-and-fees-content #month-filter").is(':checked')) return 'month'
  if (jQuery(".spend-and-fees-content #quarter-filter").is(':checked')) return 'quarter'
}

function safeNumber(value) {
  if (!value || value == undefined) return 0
  return Number(value)
}

window.bindSpendAndFeesPage = bindSpendAndFeesPage
